
import Vue from "vue";
import splitStringOnCapital from "@/plugins/filters/stringFilter";
import { decimal, numeric, or } from "vuelidate/lib/validators";
import { DELIVERY_NETWORKS, SITE_TYPES } from "@/constants/offers";

export default Vue.extend({
  props: {
    deliveryNetwork: {
      type: String,
      default: undefined
    },
    siteType: {
      type: String
    },
    value: {
      type: Object
    },
    name: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isActive: false
    };
  },
  watch: {
    value(val: any) {
      // if the value changes, update the isActive flag
      this.isActive = val && val.amountCpl !== "" && val.amountCpl > 0;
    }
  },
  computed: {
    amountCpl: {
      get(): number {
        return this.value && this.value.amountCpl;
      },
      set(value: number | string) {
        // emit the input event for any consumers to be notified of the change
        this.$emit("input", {
          deliveryNetwork: this.deliveryNetwork,
          siteType: this.siteType,
          amountCpl: value
        });
      }
    },
    label(): string {
      if (!this.siteType) {
        return "";
      }

      // For now, just split the site type
      return splitStringOnCapital(this.siteType);
    },
    shouldShow(): boolean {
      return !(
        this.deliveryNetwork === DELIVERY_NETWORKS.Challenge &&
        this.siteType === SITE_TYPES.TruckStop
      );
    }
  },
  methods: {
    onIsActiveChange(value: boolean) {
      this.isActive = value;

      // if switched off
      if (!value) {
        // zero the amount which will clear out the discount
        this.amountCpl = 0;
      }
    }
  },
  // this is not working!!!
  validations() {
    return {
      amountCpl: {
        number: or(decimal, numeric)
      }
    };
  }
});
